import { lerpColor } from '../../color';
import { hsl, type World } from '../../world';
import { dress, fx } from './dress';
import { paint } from './paint';
import './world.css';

const H = 315;
const S = 38;
const ACCENT1 = 85;
const ACCENT2 = 330;
const LIGHT = hsl(H, 72, 82);
const HELD = hsl(ACCENT1, 88, 78);
const SPOT = hsl(ACCENT2, 85, 76);
const RIM = hsl(H, 45, 92);

const world: World = {
  id: 'baile-na-laje',
  name: 'Baile na Laje',
  seed: 'baile-na-laje',
  legacy: false,
  hue: H,
  ceil: hsl(H, 0.8 * S, 28),
  font: 'Rubik Spray Paint',
  fontFile: 'rubik-spray-paint-400.woff2',
  fontWeight: '400',
  fontLicense: 'OFL-1.1',
  dark: true,
  boil: false,
  glow: 'add',
  glowAlpha: 0.26,
  fillAlpha: 0.62,
  palette: {
    bg: hsl(H, S, 10),
    ink: hsl(H, S + 12, 5),
    rim: RIM,
    held: HELD,
    heldShade: hsl(ACCENT1, 60, 60),
    heldLight: hsl(ACCENT1, 90, 90),
    incoming: {
      circle: LIGHT,
      square: SPOT,
      triangle: lerpColor(LIGHT, HELD, 0.5),
      hex: lerpColor(LIGHT, SPOT, 0.5),
    },
    spot: SPOT,
    path: hsl(H, 30, 72),
    text: hsl(H, 40, 94),
    sparks: [HELD, SPOT, LIGHT, RIM],
  },
  burst: { count: 12, speed: 0.6, drag: 3, gravity: 0.5, spin: 6, life: 1, sizeMin: 0.009, sizeMax: 0.02 },
  dress,
  fx,
  paint,
};

export default world;
